import http from "network/index.js";

// 登录
export function login(params) {
  return http.post("/login", params);
}

/**
 * 角色：专家和采购人
 */
// 采购人、专家，打分项目列表
export function scoreList(params) {
  return http.post("/scoreList", params);
}

// 采购人、专家，提交分数
export function sendScore(params) {
  return http.post("/scores/projects", params);
}

// 采购人、专家，查看自己的分数
export function getMyScore(param) {
  return http.get("/scores/experts/" + param);
}

// 采购人查看专家的打分情况
export function getExpertScore(param) {
  return http.get("/scores/experts/projects/" + param);
}

/**
 * 角色：监管部门
 */
// 监管部门，违规列表
export function getMatterInfo(params) {
  return http.post("/feedback/query", params);
}

// 新建时，查询全部机构的信息
export function getAgencyInfo(param) {
  return http.get("/agencies?searchKey=" + param);
}

// 监管部门，新增违规信息
export function saveMatter(params) {
  return http.post("/feedback", params);
}

// 监管部门，查看某一条违规信息
export function getMatterDetail(param) {
  return http.get("/feedback/query/" + param);
}

// 监管部门，修改某一条违规信息
export function editMatter(params) {
  return http.put("/feedback", params);
}

// 监管部门，删除某一条违规信息
export function deleteMatter(param) {
  return http.delete("/feedback/" + param);
}

// 监管部门，打分项目列表
export function getScoreList(params) {
  return http.post("/projects/query", params);
}

// 某一个项目的打分状态
export function getScoreDetail(param) {
  return http.get("/scores/projects/" + param);
}

// 监管部门，概况页面数据列表
export function getSurveyList(params) {
  return http.post("/total/generalSituation", params);
}

// 采购人、监管部门，修改密码
export function changePasswd(params) {
  return http.put("/user/password", params);
}

// 监管部门，代理机构申报列表
export function getDeclaraList(params) {
  return http.post("/agencyInfos/query", params);
}

// 查看某一条代理机构申报信息
export function getDeclaraDetail(param) {
  return http.get("/agencyInfos/" + param);
}

// 编辑代理机构申报
export function editDeclara(id, params) {
  return http.post("/agencyInfos/batch/" + id, params);
}

/**
 * 2023-10-31
 * 修改
 */
// 监管部门，获取代理机构+监管部门对专家的打分列表
export function getAgencyAndOfficeScore(params) {
  return http.post("/expertScores/szTotal", params);
}

export const getExpertScoreOfAgency = (params) => {
  return http.post("/expertScores/szAgencyScore", params);
};

// 新增，监管部门对专家打分
export const postExpertScore = (params) => {
  return http.post("/expertScores/submitSzExpertScore", params);
};

// 监管部门，导出专家平均分
export function exportData(params, opt) {
  return http.post("/expertScores/getSzTotalScoreToExcel", params, opt);
}

// 监管部门，查看代理机构的基本信息列表
export function getBaseList(params) {
  return http.post("/agencyBaseInfo/query", params);
}

// 监管部门，查看单个专职人员名单
export function getStaffDetail(id, params) {
  return http.post("/timeStaff/agencyBaseInfo/" + id, params);
}

/**
 * 角色：代理机构
 */
// 代理机构，查看项目列表
export function getProjectList(params) {
  return http.post("/projects/agencyGetProjectExpertScoreDeduct", params);
}

// 代理机构，提交给专家的打分
export function saveExpertScore(params) {
  return http.post("/scores/scoreDeductSubmit", params);
}

// 代理机构，获取自己的id、name、code
export function getSelfInfo() {
  return http.get("agencies/ownAgency");
}

// 代理机构，第一次提交自己的基本信息
export function firstUploadInfo(params) {
  return http.post("/agencyBaseInfo", params);
}

// 代理机构，修改后上传信息
export function editBaseInfo(params) {
  return http.put("/agencyBaseInfo", params);
}

// 代理机构，获取自己的基本信息，如果没有上传过自己的信息，则为空
export function getBaseInfo(agencyId) {
  return http.get("/agencyBaseInfo/" + agencyId);
}

/**
 * 新增2012/10/27 代理机构
 */
export const uploadFile = (file) => {
  return http.post("/file/upload", file);
};

// 公示页面
export function getPublicityList(params) {
  return http.post("/total/behaviorEvaluation", params);
}

// admin用户
export function getAllUserInfo(params) {
  return http.post("/allUsers", params);
}

// 重置用户密码
export function resetPwd(id, params) {
  return http.put("/user/forceUpdatePass/" + id, params);
}
